import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 20px 50px 0 0;

  .pagination {
    font-size: 14px;
    font-weight: 600;
    display: flex;
    list-style-type: none;

    a {
      border: 1px solid #e9ecef;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #8898aa;
      cursor: pointer;
    }

    li {
      &.previous {
        margin-right: 21px;
        margin-left: 0;
      }

      &.next {
        margin-right: 0;
        margin-left: 21px;
      }

      &.disabled {
      }

      &.active {
        a {
          border: 1px solid var(--primary-color);
          background-color: var(--primary-color);
          color: #fff;
          cursor: default;
          user-select: none;
          outline: none;
        }

        svg {
          color: var(--primary-color) !important;
        }
      }

      & + li {
        margin-right: 0;
        margin-left: 10px;
      }
    }
  }
`
